import Highcharts from 'highcharts';
import 'highcharts/modules/accessibility';
import 'highcharts/modules/pattern-fill';

/**
 * In Highcharts v12, built-in patterns are no longer pre-registered as SVG
 * <pattern> elements with stable IDs. The PatternFill module only creates SVG
 * patterns when a series color is a { pattern: {...} } or { patternIndex: N }
 * object — a plain "url(#id)" string bypasses it entirely.
 *
 * We therefore register the 10 built-in patterns manually via
 * renderer.addPattern() on every chart render, giving each one the stable ID
 * "highcharts-default-pattern-{N}" so CSS variables of the form
 * url(#highcharts-default-pattern-N) continue to resolve correctly.
 *
 * Paths and dimensions mirror v12's internal createPatterns() function so that
 * { patternIndex: N } and url(#highcharts-default-pattern-N) are visually
 * equivalent.
 */
const patternDefs = [
  { d: 'M 0 0 L 5 5 M 4.5 -0.5 L 5.5 0.5 M -0.5 4.5 L 0.5 5.5', width: 5, height: 5, patternTransform:"scale(1.4 1.4)"  },
  { d: 'M 0 5 L 5 0 M -0.5 0.5 L 0.5 -0.5 M 4.5 5.5 L 5.5 4.5', width: 5, height: 5, patternTransform:"scale(1.4 1.4)" },
  { d: 'M 2 0 L 2 5 M 4 0 L 4 5', width: 5, height: 5, patternTransform:"scale(1.4 1.4)" },
  { d: 'M 0 2 L 5 2 M 0 4 L 5 4', width: 5, height: 5, patternTransform:"scale(1.4 1.4)" },
  { d: 'M 0 1.5 L 2.5 1.5 L 2.5 0 M 2.5 5 L 2.5 3.5 L 5 3.5', width: 5, height: 5, patternTransform:"scale(1.4 1.4)" },
  { d: 'M 0 0 L 5 10 L 10 0', width: 10, height: 10,  },
  { d: 'M 3 3 L 8 3 L 8 8 L 3 8 Z', width: 10, height: 10,  },
  { d: 'M 5 5 m -4 0 a 4 4 0 1 1 8 0 a 4 4 0 1 1 -8 0', width: 10, height: 10,  },
  { d: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11', width: 10, height: 10,  },
  { d: 'M 0 10 L 10 0 M -1 1 L 1 -1 M 9 11 L 11 9', width: 10, height: 10,  },
];

const defaultColors = Highcharts.getOptions().colors;

// renderer.addPattern() is idempotent — it checks renderer.defIds and skips
// IDs that are already registered, so re-renders and multiple charts are safe.
Highcharts.addEvent(Highcharts.Chart, 'render', function () {
  const renderer = this.renderer;
  if (!renderer?.addPattern) return;

  patternDefs.forEach((def, i) => {
    renderer.addPattern({
      id: `highcharts-default-pattern-${i}`,
      path: def.d,
      color: defaultColors[i],
      width: def.width,
      height: def.height,
      ...(def.patternTransform && { patternTransform: def.patternTransform }),
    });
  });
});

export default Highcharts;
